import React from 'react';
import { number } from 'prop-types';

// Components
import { Box, Divider, Skeleton } from '@mui/material';

const SelectorSkeleton = ({ skeletonHeight }) => (
  <>
    <Box
      data-testid="skeleton"
      display="flex"
      flexDirection="column"
      height={skeletonHeight}
      p={3}
      width="100%"
    >
      <Box mb={1}>
        <Skeleton borderradius={1} height={25} mb={3} variant="rectangular" width="75%" />
      </Box>
      <Box display="flex">
        <Box mb={1} mr={2}>
          <Skeleton borderradius={2} height={20} variant="rectangular" width={25} />
        </Box>
        <Skeleton borderradius={1} height={20} variant="text" width="75%" />
      </Box>
      <Box display="flex">
        <Box mr={2}>
          <Skeleton borderradius={2} height={20} variant="rectangular" width={25} />
        </Box>
        <Skeleton borderradius={1} height={20} variant="text" width="75%" />
      </Box>
    </Box>
    <Divider />
  </>
);

SelectorSkeleton.propTypes = {
  skeletonHeight: number.isRequired,
};

export default SelectorSkeleton;
